const SkillEditorActionConstants = {
  SET_USER_OTHER_SKILLS: 'SET_USER_OTHER_SKILLS',
  SET_VALIDATION_ERROR: 'SET_VALIDATION_ERROR'
};

const setUserOtherSkills = (skills) => {
  return { type: SkillEditorActionConstants.SET_USER_OTHER_SKILLS, payload: skills };
};

const setValidationError = (error) => {
  return { type: SkillEditorActionConstants.SET_VALIDATION_ERROR, payload: error };
};

export default {
  SkillEditorActionConstants,
  setUserOtherSkills,
  setValidationError
};
